/**
 * Stories implemented
 */
/* eslint-disable local-rules/require-storybook-documentation */
import type { FunctionComponent } from 'react';
import { Paragraph } from '@zillow/constellation-10';
import { HumanReadableHelpHotline } from 'src/common/constants';
import { PhoneLink } from 'src/components/Typography/PhoneLink';
import { getPhoneNumber } from 'src/components/Typography/PhoneLink/utils/getPhoneNumber';
import { ErrorPage } from '../components/ErrorPage';

export const UnauthorizedPage: FunctionComponent = () => (
    <ErrorPage
        headingText="You are not authorized to access this page"
        subHeadingText={
            <Paragraph>
                Please try logging in with a different account or call us at{' '}
                <PhoneLink {...getPhoneNumber(HumanReadableHelpHotline.CUSTOMER_EXPERIENCE)} /> with any questions about
                Zillow Home Loans, including updates on your loan application.
            </Paragraph>
        }
    />
);
